import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { MdKeyboardArrowDown, MdDeleteOutline } from 'react-icons/md'
import styles from './styles.module.scss'
import BreadCrumbs from '../../../assets/BreadCrumbs'

const TABS = [
  'Общее',
  'Плановая таблица',
  'Список литературы',
  'Средства проведения занятия',
  'Файлы для обучающихся',
  'Файлы для преподавателя',
  'Электронное тестирование',
]

// --- mock-данные для верстки ---
const lesson = {
  date: '16.11.2025',
  room: '2-127',
  group: '0007/1',
  hours: '3-4',
  teacher: 'Алимов Р.М.',
  cathedra: '14 кафедра стартовых и технических комплексов',
  discipline: 'Военно-профессиональная практика (практика в несении внутренней и караульной служб)',
}

const SelectArrow = () => <MdKeyboardArrowDown size={24} className={styles.selectArrow} />

const Plan = () => {
  const { pathname } = useLocation()
  const [activeTab, setActiveTab] = useState('Общее')

  const breadcrumbsData = [
    { label: 'Журнал учета учебных занятий', to: '/journal' },
    { label: lesson.date, to: pathname.replace(/\/plan$/, '') },
    { label: 'План проведения занятия' },
  ]

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <BreadCrumbs data={breadcrumbsData} />

        <div className={styles.titleRow}>
          <h1 className={styles.title}>План проведения занятия</h1>
          <button type="button" className={styles.clearLink}>
            <MdDeleteOutline size={20} />
            Очистить план занятия
          </button>
        </div>

        <div className={styles.tabs}>
          {TABS.map(tab => (
            <button
              key={tab}
              type="button"
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className={styles.meta}>
          <div className={styles.metaRow}>
            <span><span className={styles.metaLabel}>Дата</span> {lesson.date}</span>
            <span><span className={styles.metaLabel}>Аудитория</span> {lesson.room}</span>
            <span><span className={styles.metaLabel}>Учебная группа</span> {lesson.group}</span>
          </div>
          <div className={styles.metaRow}>
            <span><span className={styles.metaLabel}>Учебные часы</span> {lesson.hours}</span>
            <span><span className={styles.metaLabel}>Преподаватель</span> {lesson.teacher}</span>
            <span><span className={styles.metaLabel}>Читающая кафедра</span> {lesson.cathedra}</span>
          </div>
          <div className={styles.metaRow}>
            <span><span className={styles.metaLabel}>Дисциплина</span> {lesson.discipline}</span>
          </div>
        </div>

        {activeTab === 'Общее' ? (
          <>
            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Позиционирование занятия</h2>
              <div className={styles.row}>
                <label className={`${styles.field} ${styles.fieldWide}`}>
                  <span className={styles.fieldLabel}>Вид занятия</span>
                  <div className={styles.selectWrap}>
                    <select className={styles.select} defaultValue="Лекция">
                      <option>Лекция</option>
                    </select>
                    <SelectArrow />
                  </div>
                </label>
                <label className={`${styles.field} ${styles.fieldSmall}`}>
                  <span className={styles.fieldLabel}>№ занятия (сквозной)</span>
                  <input className={styles.input} type="number" placeholder="0" />
                </label>
              </div>
              <div className={styles.row}>
                <div className={`${styles.field} ${styles.fieldWide}`}>
                  <div className={styles.labelRow}>
                    <span className={styles.fieldLabel}>Номер и наименование раздела и темы</span>
                    <label className={styles.radio}>
                      <input type="radio" name="showAll" /> Показать все
                    </label>
                  </div>
                  <div className={styles.selectWrap}>
                    <select className={styles.select} defaultValue="Не выбрано">
                      <option>Не выбрано</option>
                    </select>
                    <SelectArrow />
                  </div>
                </div>
                <label className={`${styles.field} ${styles.fieldSmall}`}>
                  <span className={styles.fieldLabel}>№ занятия (по теме)</span>
                  <input className={styles.input} type="number" placeholder="0" />
                </label>
              </div>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Что изучается на занятии</h2>
              <label className={`${styles.field} ${styles.fieldMid}`}>
                <span className={styles.fieldLabel}>Тема занятия</span>
                <input className={styles.input} placeholder="Введите текст" />
              </label>
              <label className={`${styles.field} ${styles.fieldFull}`}>
                <span className={styles.fieldLabel}>Учебные вопросы</span>
                <textarea className={styles.textarea} placeholder="Введите текст" />
              </label>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Цели занятия</h2>
              <label className={`${styles.field} ${styles.fieldFull}`}>
                <span className={styles.fieldLabel}>Цели проведения</span>
                <textarea className={styles.textarea} placeholder="Введите текст" />
              </label>
              <label className={`${styles.field} ${styles.fieldFull}`}>
                <span className={styles.fieldLabel}>Воспитательные цели</span>
                <textarea className={styles.textarea} placeholder="Введите текст" />
              </label>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Дополнительные параметры</h2>
              <div className={styles.paramsRow}>
                <label className={`${styles.field} ${styles.fieldSmall}`}>
                  <span className={styles.fieldLabel}>Кол-во работ</span>
                  <input className={styles.input} type="number" placeholder="0" />
                </label>
                <div className={styles.checkboxes}>
                  <label className={styles.checkboxLabel}>
                    <input type="checkbox" /> Рубежный контроль
                  </label>
                  <label className={styles.checkboxLabel}>
                    <input type="checkbox" /> Гриф секретности занятия
                  </label>
                  <label className={styles.checkboxLabel}>
                    <input type="checkbox" /> Открытое занятие
                  </label>
                </div>
              </div>
            </section>

            <div className={styles.actions}>
              <button type="button" className={styles.saveButton}>Сохранить</button>
            </div>
          </>
        ) : (
          <div className={styles.placeholder}>Раздел «{activeTab}» в разработке</div>
        )}
      </div>
    </div>
  )
}

export default Plan
